import Header from "../components/Header";

function ArchivePage() {
  return (
    <div className="text-white">
      <Header />
      <div>
        <div className="flex flex-col items-center justify-center p-4">
          <h1 className="text-4xl font-bold">The Archive</h1>
          <div className="text-lg">Coming soon!</div>
        </div>
      </div>
    </div>
  );
}

export default ArchivePage;
